import { type APPLICANT_ATTRIBUTION_BOTH_TYPE, LOAN_REQUEST_COMMANDS } from 'cpool-constants';

import { SONSTIGE_VERBINDLICHKEITEN } from '../../../types';
import { InstallmentLoanFields } from '../shared/InstallmentLoanFields';

type Props = {
    index: number;
    applicant: APPLICANT_ATTRIBUTION_BOTH_TYPE;
};

export const LoanForm: React.FC<Props> = ({ applicant, index }) => (
    <InstallmentLoanFields
        type={SONSTIGE_VERBINDLICHKEITEN}
        index={index}
        applicant={applicant}
        commandName={LOAN_REQUEST_COMMANDS.changeLiabilityOther}
    />
);
